<template>
  <div class="liquidity-calc-property-market-values">
    <v-row no-gutters>
      <v-col cols="12" sm="8" md="9">
        <p class="field-label mb-0">{{ property.physicalAddress }}</p>
      </v-col>
      <v-col
        cols="12"
        sm="4"
        md="3"
        :class="{ 'mt-6': $vuetify.breakpoint.smAndDown }"
      >
        <ValidationProvider
          :id="'market_value' + property.id"
          v-slot="{ errors }"
          :vid="'market_value' + property.id"
          name="market_value"
          :rules="{ required: true, min_currency: 1 }"
        >
          <TextField
            v-model="currencyMarketValue"
            :prefix="'R'"
            :pattern="'[0-9\s]*'"
            @keypress="isNumber($event)"
            @input="handleInput"
            :errors="errors"
          />
        </ValidationProvider>
      </v-col>
    </v-row>

    <v-row no-gutters>
      <v-col cols="12" sm="8" md="9">
        <p
          v-if="ownershipDetailsPresent"
          class="text-primary-color font-weight-bold"
        >
          {{ ownership }}
        </p>
        <p v-else class="error-text">
          Ownership details missing - please complete property details in the
          <router-link to="/assets-overview">assets overview</router-link>
        </p>

        <!-- Validation to ensure property ownership is present before submitting liquidity calculator details. Error message is already present above -->
        <ValidationProvider
          :id="'ownership_present' + property.id"
          :vid="'ownership_present' + property.id"
          name="ownership_present"
          :rules="{ is: [true] }"
        >
          <input v-model="ownershipDetailsPresent" type="hidden" />
        </ValidationProvider>
      </v-col>
      <v-col cols="12" sm="4" md="3">
        <p v-if="isCoOwned" class="text-primary-color font-weight-bold">
          R {{ ownershipValue | currency }}
        </p>
      </v-col>
    </v-row>
  </div>
</template>

<script>
  import {
    formatCurrency,
    parseCurrency,
    isNumberCheck,
  } from '../../constants/js/currency-input';

  export default {
    name: 'PropertyMarketValue',
    props: {
      property: {
        required: true,
        type: Object,
      },
      value: {
        required: true,
      },
    },
    data() {
      return {
        marketValue: this.value ? this.value['marketValue'] : null,
      };
    },
    computed: {
      currencyMarketValue: {
        get: function () {
          return formatCurrency(this.marketValue);
        },
        set: function (newValue) {
          this.marketValue = parseCurrency(newValue);
        },
      },
      ownershipValue() {
        switch (this.property.ownership) {
          case 'SOLE_OWN':
            return this.marketValue;
          case 'CO_OWN':
            return parseInt(
              this.marketValue * (this.property.percentageShare / 100)
            );
          case 'CO_OWN_WITH_SPOUSE':
            return parseInt(
              this.marketValue * (this.property.percentageShare / 100)
            );
          case 'SPOUSE_SOLE_OWNER':
            return 0;
          default:
            return this.marketValue;
        }
      },
      ownership() {
        switch (this.property.ownership) {
          case 'SOLE_OWN':
            return 'Sole owner';
          case 'CO_OWN_WITH_SPOUSE':
            return 'Co-own with spouse - ' + this.percentageShare;
          case 'CO_OWN':
            return 'Co-own - ' + this.percentageShare;
          case 'SPOUSE_SOLE_OWNER':
            return 'Spouse is the sole owner';
          default:
            return 'Ownership unknown - please complete property details in the assets section';
        }
      },
      percentageShare() {
        return this.property.percentageShare
          ? this.property.percentageShare + '%'
          : null;
      },
      isCoOwned() {
        return (
          this.property.ownership == 'CO_OWN_WITH_SPOUSE' ||
          this.property.ownership == 'CO_OWN'
        );
      },
      percentageSharePresent() {
        return this.isCoOwned ? this.property.percentageShare : true;
      },
      ownershipDetailsPresent() {
        return this.property.ownership && this.percentageSharePresent
          ? true
          : false;
      },
    },
    created() {
      this.handleInput(null);
    },
    methods: {
      handleInput(_e) {
        this.$emit('input', {
          marketValue: this.marketValue,
          ownershipValue: this.ownershipValue,
        });
      },
      isNumber(event) {
        isNumberCheck(event);
      },
    },
  };
</script>

<style lang="scss">
  .liquidity-calc-property-market-values {
    .v-input__slot {
      margin-bottom: 0;
    }

    .field-label {
      margin-top: 22px !important;
    }
  }
</style>
